import ManageAnnualFees from "./ManageAnnualFees";
import { AdministrationServicePath, ANNUAL_FEES, SPECIALITIES } from "utils/constants";

export const resources = {
  name: AdministrationServicePath + SPECIALITIES + "/" + ANNUAL_FEES,
  title: "Годишни такси",
  list: null,
  edit: <ManageAnnualFees />,
  // editPermission: permissions.canUpdateProfessionalDirections,
  // permission: permissions.canPreviewProfessionalDirections,
};
